<template>
	<v-row class="magic-token-page ma-0" justify="center" align="center">
		<div class="text-center ma-12" v-if="loading">
			<v-progress-circular :indeterminate="true" size="200" color="light-blue"></v-progress-circular>
		</div>
		<v-card v-else-if="ready" width="420" class="pa-6 text-center">
			<v-card-title class="justify-center">Continue to your client portal</v-card-title>
			<v-card-text>Your secure sign-in link is ready.</v-card-text>
			<v-btn color="primary" block large :loading="working" @click="continueSignIn">Continue to sign in</v-btn>
		</v-card>
		<v-dialog v-model="dialog" persistent max-width="290">
			<v-card>
				<v-card-text style="padding-top: 15px;">{{ $t('login.token-expired') }}</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="red darken-1" text @click="freshLogin()">{{ $t('global.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
	import qs from 'qs';
	import AuthService from "@/modules/auth/AuthService";

	export default {
		name: 'MagicToken',

		data() {
			return {
				magicToken: null,
				origUri: null,
				dialog: false,
				loading: true,
				ready: false,
				working: false,
			};
		},

		methods: {
			freshLogin() {
				self.location.href = document.location.protocol + '//' + document.location.host + '/login';
			},
			continueSignIn() {
				this.working = true;
				AuthService.magicToken(this.magicToken)
					.then(() => {
						this.origUri = (this.origUri || '/welcome').replace('@','');
						self.location.href = document.location.protocol + '//' + document.location.host + this.origUri;
					})
					.catch((err) => {
						console.log('Failed to fetch refresh token:' + err);
						this.ready = false;
						this.dialog = true;
					})
					.finally(() => this.working = false);
			},
		},

		async mounted() {
      let queryString = qs.parse(self.location.search.slice(1));
      this.magicToken = queryString['magicToken'];
			this.origUri = queryString['origUri'];

			try {
				this.ready = !!this.magicToken && await AuthService.peekMagicToken(this.magicToken);
				if (!this.ready) this.dialog = true;
			} catch (err) {
				this.dialog = true;
			} finally {
				this.loading = false;
			}
		},

	};
</script>

<style scoped>
	.magic-token-page {
		width: 100%;
		min-height: 100vh;
	}
</style>
